module.exports = __webpack_public_path__ + "img/care3.f4f50f20.png";